import PnlPage from "@Quest/ProjectPlans/Pages/PnlPage.vue";
import ProjectCapexPage from "@Quest/ProjectPlans/Pages/ProjectCapexPage.vue";
import ProjectExpenseAllocationsPage from "@Quest/ProjectPlans/Pages/ProjectExpenseAllocationsPage.vue";
import ProjectExpenseSavingsPage from "@Quest/ProjectPlans/Pages/ProjectExpenseSavingsPage.vue";
import ProjectMarginsPage from "@Quest/ProjectPlans/Pages/ProjectMarginsPage.vue";
import ProjectResourceAllocationsPage from "@Quest/ProjectPlans/Pages/ProjectResourceAllocationsPage.vue";
import ProjectResourceCostsPage from "@Quest/ProjectPlans/Pages/ProjectResourceCostsPage.vue";
import ProjectResourceSavingsPage from "@Quest/ProjectPlans/Pages/ProjectResourceSavingsPage.vue";
import ProjectRevenuesPage from "@Quest/ProjectPlans/Pages/ProjectRevenuesPage.vue";
import ProjectPhasesPage from "@Quest/ProjectPlans/Pages/ProjectPhasesPage.vue";
import ManageProjectPlansPage from "@Quest/ProjectPlans/Pages/ManageProjectPlansPage.vue";
import ProjectPlanSettingsPage from "@Quest/ProjectPlans/Pages/ProjectPlanSettingsPage.vue";
import ProjectPlanSummaryPage from "@Quest/ProjectPlans/Pages/ProjectPlanSummaryPage.vue";


export const routes = [
    {
        path: "/q/project/versions/:workspaceId/:tchProjectId/:projectId",
        name: "q-project-versions-path",
        component: ManageProjectPlansPage
    },

    {
        path: "/q/project/settings/:workspaceId/:tchProjectId/:projectId/:planId?",
        name: "q-project-settings-path",
        component: ProjectPlanSettingsPage
    },
    {
        path: "/q/project/summary/:workspaceId/:tchProjectId/:projectId/:planId?",
        name: "q-project-summary-path",
        component: ProjectPlanSummaryPage
    },
    {
        path: "/q/project/revenues/:workspaceId/:tchProjectId/:projectId/:planId?",
        name: "q-project-revenues-path",
        component: ProjectRevenuesPage
    },
    {
        path: "/q/project/margins/:workspaceId/:tchProjectId/:projectId/:planId?",
        name: "q-project-margins-path",
        component: ProjectMarginsPage
    },
    {
        path: "/q/project/pnl/:workspaceId/:tchProjectId/:projectId/:planId?",
        name: "q-project-pnl-path",
        component: PnlPage
    },
    {
        path: "/q/project/expense-allocations/:workspaceId/:tchProjectId/:projectId/:planId?",
        name: "q-project-expense-allocations-path",
        component: ProjectExpenseAllocationsPage
    },
    {
        path: "/q/project/expense-savings/:workspaceId/:tchProjectId/:projectId/:planId?",
        name: "q-project-expense-savings-path",
        component: ProjectExpenseSavingsPage
    },
    {
        path: "/q/project/resource-allocations/:workspaceId/:tchProjectId/:projectId/:planId?",
        name: "q-project-resource-allocations-path",
        component: ProjectResourceAllocationsPage
    },
    {
        path: "/q/project/resource-savings/:workspaceId/:tchProjectId/:projectId/:planId?",
        name: "q-project-resource-savings-path",
        component: ProjectResourceSavingsPage
    },
    {
        path: "/q/project/resource-costs/:workspaceId/:tchProjectId/:projectId/:planId?",
        name: "q-project-resource-costs-path",
        component: ProjectResourceCostsPage
    },
    {
        path: "/q/project/capex/:workspaceId/:tchProjectId/:projectId/:planId?",
        name: "q-project-capex-path",
        component: ProjectCapexPage
    },
    {
        path: "/q/project/phases/:workspaceId/:tchProjectId/:projectId/:planId?",
        name: "q-project-phases-path",
        component: ProjectPhasesPage
    },
]
